import React, { useState, useEffect, useRef } from 'react';
// import moment from 'moment';
import { useToast } from 'react-native-toast-notifications';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { BLink, Page, showToast } from '../../../components';
import { Input, Button, FormContainer, ButtonContainer, InputRefProps, TextContainer } from '../../../components/Form';
import { UserModel, UserInputSchema /** MasterCityModel,  MasterStateModel */ } from '../../../types';
import { yupErrorsMessage } from '../../../utils/yup';
// import getService from '../../../services/geoService';
import userService from '../../../services/userService';
import { fetchUserProfile } from '../../../store/user/userActions';
import { setLoading } from '../../../store/portal/portalActions';
import { isEmpty } from '../../../utils/helper';

export const MySettingProfile = ({ navigation }: any) => {
  const toast = useToast();
  const dispatch = useAppDispatch();
  const rtProfile = useAppSelector(s => s.user);

  const inputMobileNo = useRef<InputRefProps>(null);
  const inputName = useRef<InputRefProps>(null);
  const inputEmail = useRef<InputRefProps>(null);
  // const inputDOB = useRef<InputRefProps>(null);
  // const inputState = useRef<InputRefProps>(null);
  // const inputCity = useRef<InputRefProps>(null);

  const [profile, setProfile] = useState<UserModel | null>(null);
  // const [selectedState, setSelectedState] = useState<string>('');
  // const [states, setStates] = useState<MasterStateModel>();
  // const [cities, setCities] = useState<MasterCityModel>();

  useEffect(() => {
    dispatch(fetchUserProfile());

    // load master data
    // dispatch(setLoading(true));
    // getService.getStates().then(res => {
    //   dispatch(setLoading(false));
    //   setStates(
    //     res.data
    //       .map((row: any) => {
    //         row.value = row.code;
    //         row.label = row.state;
    //         return row;
    //       })
    //       .sort((a: any, b: any) => a.label.localeCompare(b.label)),
    //   );
    // });
  }, []);

  useEffect(() => {
    if (!isEmpty(rtProfile)) {
      setProfile(rtProfile?.user);
    }
    dispatch(setLoading(false));
  }, [rtProfile.user]);

  useEffect(() => {
    updateInputValue(inputMobileNo.current, profile?.mobileNo || '');
    updateInputValue(inputName.current, profile?.name || '');
    updateInputValue(inputEmail.current, profile?.email || '');
    // updateInputValue(inputDOB.current, moment(profile?.dob).format('YYYY-MM-DD'));
    // if (profile !== undefined) {
    //   dispatch(setLoading(false));
    //   setSelectedState(profile?.state || '');
    // }
  }, [profile]);

  // useEffect(() => {
  //   // when state updated, fetch city
  //   if (selectedState) {
  //     dispatch(setLoading(true));
  //     getService.getCityByState(selectedState).then(res => {
  //       dispatch(setLoading(false));
  //       setCities(
  //         res.data
  //           .map((label: string) => {
  //             let row = {
  //               value: label,
  //               label: label,
  //             };

  //             return row;
  //           })
  //           .sort((a: any, b: any) => a.label.localeCompare(b.label)),
  //       );
  //     });
  //   }
  // }, [selectedState]);

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const doSaveBtn = async () => {
    dispatch(setLoading(true));

    let user: UserModel = {
      mobileNo: profile?.mobileNo,
      email: inputEmail.current?.value || null,
      name: inputName.current?.value || null,
      // dob: new Date(inputDOB.current?.value || ''),
      // state: inputState.current?.value || null,
      // city: inputCity.current?.value || null,
    };

    UserInputSchema.validate(user, { abortEarly: false, context: { isEdit: true } })
      .then(async usrObj => {
        let res = await userService.updateUser(usrObj);
        if (res.status === 200 && res.data.resultCode === 0) {
          dispatch(fetchUserProfile());
          dispatch(setLoading(false));
          showToast(toast, { message: 'Profile updated', type: 'success' });
        }
      })
      .catch(err => {
        console.log(yupErrorsMessage(err));
        showToast(toast, { message: yupErrorsMessage(err).join('\n'), type: 'error' });
        dispatch(setLoading(false));
      });
  };

  return (
    <Page title={'My Profile'}>
      <FormContainer title="">
        <Input
          label={'Mobile Number'}
          id="mobileNumber"
          value={profile?.mobileNo}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          readOnly={true}
          ref={inputMobileNo}
        />

        <Input
          label={'Name'}
          id="name"
          value={profile?.name}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          ref={inputName}
        />

        <Input
          label={'Email'}
          id="email"
          value={profile?.email}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          ref={inputEmail}
        />

        {/* <Input
          label={'Birthdate'}
          id="dob"
          type="date"
          value={profile?.dob}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          ref={inputDOB}
        /> */}

        {/* <Input
          label={'State'}
          id="state"
          type="select"
          dataSource={states}
          value={profile?.state}
          onChange={(v: string) => setSelectedState(v)}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          ref={inputState}
        /> */}

        {/* <Input
          label={'City'}
          id="city"
          type="select"
          dataSource={cities}
          value={profile?.city}
          schemaObject={UserInputSchema}
          schemaContext={{ isEdit: true }}
          ref={inputCity}
        /> */}

        <ButtonContainer>
          <Button onPress={() => doSaveBtn()}>Save</Button>
        </ButtonContainer>

        <TextContainer align="center">
          <BLink to={{ screen: 'changePassword' }}>Change Password</BLink>
        </TextContainer>
      </FormContainer>
    </Page>
  );
};
